export default __webpack_public_path__ + "static/media/ArrowDown.3c05ec10.svg";